import './index.scss';

import './support-form.scss';
import './login.scss';

class Form {
    constructor(root) {
        this.root = root;

        this.handleSuccess();
        this.handleError();
    }

    handleSuccess() {
    }

    handleError() {
        this.error = this.root.querySelector('.form-error');

        if (this.error && this.root.querySelectorAll('.has-error').length) {
            this.error.style.display = 'block';
        }
    }
}

class SupportForm {
    constructor(root) {
        this.root = root;

        this.complaintLabel = this.root.querySelector('label[for*="complaint-reason"]');
        if (this.complaintLabel) {
            this.complaintLabel.innerHTML += ' <span class="required">*</span>';
        }

        this.complaintSelect = this.root.querySelector('select[name*="[complaint-reason]"]');
        if (this.complaintSelect) {
            this.complaintText = this.complaintSelect.nextElementSibling;
            this.complaintSelect.addEventListener('change', this.handleComplaintChange.bind(this));
            this.handleComplaintChange();

            this.complaintParent = this.complaintSelect.closest('.form-group');
            this.typeSelect = this.root.querySelector('select[name*="[type]"]');
            if (this.typeSelect) {
                this.typeSelect.addEventListener('change', this.handleTypeChange.bind(this));
                this.handleTypeChange();
            }
        }
    }

    handleTypeChange() {
        if (this.typeSelect.value === 'Reklamation') {
            this.complaintSelect.required = true;
            this.complaintParent.classList.remove('hidden');
        } else {
            this.complaintSelect.required = false;
            this.complaintParent.classList.add('hidden');
        }
    }

    handleComplaintChange() {
        if (this.complaintSelect.value === 'Fremdkörper / Verunreinigungen') {
            this.complaintText.classList.remove('hidden');
        } else {
            this.complaintText.classList.add('hidden');
        }
    }
}

class LoginForm {
    constructor(root) {
        this.root = root;
    }
}

window.app.run(() => {
    document.querySelectorAll('.frame-type-form_formframework form').forEach((node) => {
        new Form(node);
    });

    document.querySelectorAll('.frame-type-form_formframework form[id*="SupportForm"]').forEach((node) => {
        new SupportForm(node);
    });

    document.querySelectorAll('.frame-type-felogin_login form').forEach((node) => {
        new LoginForm(node);
    });

    const scrollToSuccessMessage = () => {
        if (!window.location.search.includes('tx_form_formframework')) { return; }
        window.requestAnimationFrame(() => {
            window.app.scrollToHash('#wf-form-success', false);
        });
    };

    scrollToSuccessMessage();
});
